/**
 * Permet de vérifier la permission d'un objet
 * en fonction du role de l'agent
 * afin de cacher l'objet si pas de permission
 */
import store from '../store'
import {ALL_ACCESS, NO_PEONS, NO_AGENTS, NO_ADMINS, NO_PEONS_NOR_AGENTS, NO_PEONS_NO_AGENTS_NO_SUPER, NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER} from '../constants'
import _ from 'lodash'
export default {
  methods: {
    checkPermission (roles) {
      if (roles === 'NO_ADMINS') {
        return (_.indexOf(NO_ADMINS, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_AGENTS') {
        return (_.indexOf(NO_AGENTS, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_PEONS') {
        return (_.indexOf(NO_PEONS, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_PEONS_NOR_AGENTS') {
        return (_.indexOf(NO_PEONS_NOR_AGENTS, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_PEONS_NO_AGENTS_NO_SUPER') {
        return (_.indexOf(NO_PEONS_NO_AGENTS_NO_SUPER, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER') {
        return (_.indexOf(NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'ALL_ACCESS') {
        return (_.indexOf(ALL_ACCESS, store.getters['_User/account'].role) !== -1)
      }
    },
    isLevelPro () {
      if (this.$store.getters['_User/level']) {
        return (this.$store.getters['_User/level'].rights === 6)
      } else {
        return
      }
    },
    isLevelEntreprise () {
      if (this.$store.getters['_User/level']) {
        return (this.$store.getters['_User/level'].rights === 7)
      } else {
        return
      }
    },
    isLevelFaq () {
      if (this.$store.getters['_User/level']) {
        return (this.$store.getters['_User/level'].rights === 8)
      } else {
        return
      }
    },
    isLevelChat () {
      if (this.$store.getters['_User/level']) {
        return (this.$store.getters['_User/level'].rights === 10)
      } else {
        return
      }
    }
    /* checkLevelAndOption (section) {
      if (roles === 'ciblage') {
        return (_.indexOf(NO_ADMINS, store.getters['_User/account'].role) !== -1)
      }
    } */
  },
  computed: {
    // si il faut ouvrir directement un chat si idvisiteur en session chat
    getPermissions () {
      if (this.isLevelFaq()) {
        return false
      } else {
        if (this.checkPermission('NO_PEONS_NOR_AGENTS')) {
          return true
        } else {
          return false
        }
      }
    },
    getPermissionsAdmin () {
      if (this.isLevelFaq()) {
        return false
      } else {
        if (this.checkPermission('NO_PEONS_NO_AGENTS_NO_SUPER')) {
          return true
        } else {
          return false
        }
      }
    },
    getPermissionsChat () {
      if (this.isLevelFaq()) {
        return false
      } else {
        if (this.checkPermission('NO_ADMINS')) {
          return true
        } else {
          return false
        }
      }
    },
    directChat () {
      if (sessionStorage.getItem('tf-directChat')) {
        return sessionStorage.getItem('tf-directChat')
      } else {
        return false
      }
    },
    // test si sur mobile
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    // test si mobile apple ios
    isMobileIOS () {
      if (/iPhone|iPad|iPod Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/permissions.js